import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: sessionStorage.getItem('customerName&Id') || '',
};

const titleSlice = createSlice({
  name: 'title',
  initialState,
  reducers: {
    setTitle: (state, action) => {
      state.title = action.payload;
      sessionStorage.setItem('customerName&Id', action.payload);
    },
    clearTitle: (state) => {
      state.title = '';
      sessionStorage.removeItem('customerName&Id');
    },
  },
});

export const { setTitle, clearTitle } = titleSlice.actions;
export default titleSlice.reducer;
